import { render } from "./addGroup.vue?vue&type=template&id=7c5b8d24&scoped=true"
import script from "./addGroup.vue?vue&type=script&lang=js"
export * from "./addGroup.vue?vue&type=script&lang=js"

import "./addGroup.vue?vue&type=style&index=0&id=7c5b8d24&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5b8d24"],['__file',"src/views/marketing/components/addGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c5b8d24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c5b8d24', __exports__)) {
    console.log('reload')
    api.reload('7c5b8d24', __exports__)
  }
  
  module.hot.accept("./addGroup.vue?vue&type=template&id=7c5b8d24&scoped=true", () => {
    console.log('re-render')
    api.rerender('7c5b8d24', render)
  })

}


export default __exports__